"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Status_1 = __importDefault(require("@Components/Status"));
const react_1 = __importDefault(require("react"));
const overclaim_filter_status_helper_1 = require("@App/helpers/work-entities/utils/overclaim_filter_status_helper");
const OverclaimStatusIndicator = (props) => {
    const { overclaimStatus, count, withCount } = props;
    const status = (0, overclaim_filter_status_helper_1.getOverclaimStatusText)(overclaimStatus);
    return (status && (react_1.default.createElement(Status_1.default, { withCount: !!withCount, status: status, count: count, circleFirst: true, tooltip: (0, overclaim_filter_status_helper_1.getOverclaimToolTip)(overclaimStatus) })));
};
exports.default = OverclaimStatusIndicator;
